import axios from "../lib/axios";

import {
	CART_ADD_ITEM,
	CART_REMOVE_ITEM,
	CART_RESET,
	CART_SAVE_PAYMENT_RESULT,
	CART_SAVE_SHIPPING_ADDRESS,
	CART_SAVE_SUMMARY,
	CART_UPDATE_QTY,
	PROMO_CODE_SUBMITTED_FAIL,
	PROMO_CODE_SUBMITTED_REQUEST,
	PROMO_CODE_SUBMITTED_SUCCESS,
	SWATCH_CART_ADD_ITEM,
	SWATCH_CART_REMOVE_ITEM,
	SWATCH_CART_RESET,
	SWATCH_CART_SAVE_SHIPPING_ADDRESS,
} from "../constants/cartConstants";

//Adding items to Cart
export const addToCart = (data) => async (dispatch, getState) => {
	dispatch({
		type: CART_ADD_ITEM,
		payload: data,
	});
	//localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

//Removing item from cart
export const removeFromCart = (item) => (dispatch, getState) => {
	dispatch({
		type: CART_REMOVE_ITEM,
		payload: item,
	});
	//localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

//Adding items to Swatch Cart
export const addToSwatchCart = (data) => async (dispatch, getState) => {
	// Check if the item is already in the cart
	if (getState().swatchCart.swatchCartItems.length > 0) {
		let item = getState().swatchCart.swatchCartItems.find(
			(x) => x.item.code == data.item.code
		);
		console.log(item);
		// If it is, don't add it again
		if (item) {
			console.log("Item already in cart");
			return;
		}
	}

	dispatch({
		type: SWATCH_CART_ADD_ITEM,
		payload: data,
	});
	//localStorage.setItem(
	// 	"swatchCartItems",
	// 	JSON.stringify(getState().swatchCart.swatchCartItems)
	// );
};

//Removing item from Swatch cart
export const removeFromSwatchCart = (item) => (dispatch, getState) => {
	dispatch({
		type: SWATCH_CART_REMOVE_ITEM,
		payload: item,
	});
	// //localStorage.setItem(
	// 	"swatchCartItems",
	// 	JSON.stringify(getState().swatchCart.swatchCartItems)
	// );
};

export const updateProductQuantity =
	(index, quantity) => (dispatch, getState) => {
		dispatch({
			type: CART_UPDATE_QTY,
			payload: { index, quantity },
		});
	};

//Saving Shipping address to Local storage
export const saveShippingAddress = (data) => (dispatch) => {
	dispatch({
		type: CART_SAVE_SHIPPING_ADDRESS,
		payload: data,
	});
	//localStorage.setItem("shippingAddress", JSON.stringify(data));
};

export const saveSwatchShippingAddress = (data) => async (dispatch) => {
	dispatch({
		type: SWATCH_CART_SAVE_SHIPPING_ADDRESS,
		payload: data,
	});
	//localStorage.setItem("swatchShippingAddress", JSON.stringify(data));
};

//Saving CartSummery
export const saveCartSummary = (data) => async (dispatch) => {
	dispatch({
		type: CART_SAVE_SUMMARY,
		payload: data,
	});
	//localStorage.setItem("cartSummary", JSON.stringify(data));
};

//Saving Paypal method to Local storage
export const savePaymentResult = (data) => (dispatch) => {
	dispatch({
		type: CART_SAVE_PAYMENT_RESULT,
		payload: data,
	});
	//localStorage.setItem("paymentResult", JSON.stringify(data));
};

//Saving Payment method to Local storage
export const resetCart = () => (dispatch, getState) => {
	dispatch({
		type: CART_RESET,
		payload: "No Items Found",
	});
	//localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

export const resetSwatchCart = () => async (dispatch, getState) => {
	dispatch({
		type: SWATCH_CART_RESET,
		payload: "No Items Found",
	});
	return true;
	//localStorage.setItem(
	// 	"swatchCartItems",
	// 	JSON.stringify(getState().swatchCart.swatchCartItems)
	// );
};

export const readPromo = async (code, userId) => {
	const data = await axios.get(`promo/readCode?code=${code}&userId=${userId}`);
	return data;
};

export const cancelPromoCode =
	(usersId, code) => async (dispatch, getState) => {
		try {
			dispatch({
				type: PROMO_CODE_SUBMITTED_REQUEST,
			});

			const { data } = await axios.put(`promo/code`, {
				usersId: usersId,
				code: code,
			});

			dispatch({
				type: PROMO_CODE_SUBMITTED_SUCCESS,
				payload: data,
			});
		} catch (error) {
			dispatch({
				type: PROMO_CODE_SUBMITTED_FAIL,
				payload:
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
			});
		}
	};

export const makePromoCode = async (promoCode) => {
	if (typeof promoCode !== "string" || promoCode.length === 0) {
		throw new Error("Invalid promo code");
	}

	try {
		const res = await axios.post("/promo/generateCode", {
			promoCode: promoCode,
		});
		return res.data;
	} catch (error) {
		console.error("Error generating promo code:", error);
		throw error; // Rethrow the error after logging it
	}
};
